const isNullOrEmpty = <T>(array: Array<T | object>) => !(array && array.length > 0);

const ListUtils = {
  isNullOrEmpty,
};

export default ListUtils;
